import { IColumns } from '../../../../../../components/Dashboard/TableSmall'

export interface IData {
  asset: string
  amount: string
}

export interface IColumn {
  fiatColumns: IColumns[]
  cryptoColumns: IColumns[]
}

export const columns: IColumn = {
  fiatColumns: [
    {
      id: 'fiatСurrencies',
      label: 'FIAT CURRENCIES',
    },
  ],
  cryptoColumns: [
    {
      id: 'cryptoСurrencies',
      label: 'CRYPTO CURRENCIES',
    },
  ],
}

export const stateData = [
  {
    asset: 'EUR',
    amount: '1.000.00',
  },
  {
    asset: 'GBP',
    amount: '500.00',
  },
  {
    asset: 'USD',
    amount: '15.500.00',
  },
  {
    asset: 'BTC',
    amount: '510.00',
  },
  {
    asset: 'ETH',
    amount: '2.000.00',
  },
  {
    asset: 'USDT',
    amount: '150.00',
  },
]
